import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { BrowsePage } from '@search/browse/browse.page';
import { BrowserPageTitle } from '@shared/constants/browser-page-title.enum';

const routes: Routes = [
  {
    path: '',
    component: BrowsePage,
    pathMatch: 'full',
    data: { title: BrowserPageTitle.browseProducts },
  },
  {
    path: 'categories',
    loadChildren: () =>
      import('./pages/browse-categories/browse-categories.module').then(
        m => m.BrowseCategoriesModule,
      ),
  },
  {
    path: 'categories/:classCode',
    loadChildren: () =>
      import('./pages/browse-sub-categories/browse-sub-categories.module').then(
        m => m.BrowseSubCategoriesModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BrowseRoutingModule {}
